module.exports = __webpack_public_path__ + "img/nullchild.7cd2dfdb.png";